import React from 'react';
import { X } from 'lucide-react';

export const FilterSelect = ({ value, onChange, options, placeholder }) => {
  return (
    <div className="relative flex items-center w-full">
      <select
        value={value}
        onChange={(e) => 
          onChange(e.target.value)
        }
        className={`w-full px-3 py-2 pr-8 rounded-lg border transition-all duration-200 bg-gray-700 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer appearance-none ${
          value ? 'border-blue-500/50 bg-gray-700/90' : 'border-gray-600 hover:border-gray-500'
        }`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option?.charAt(0).toUpperCase() + option?.slice(1) || 'N/A'}
          </option>
        ))}
      </select>
      {value && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onChange('');
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-gray-600/50 text-gray-400 hover:text-red-400 transition-colors duration-200 flex items-center justify-center z-10"
          title="Clear filter"
          type="button"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
      {!value && (
        <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      )}
    </div>
  );
};
